import { render, staticRenderFns } from "./ApproveForm.vue?vue&type=template&id=6a95404c&"
import script from "./ApproveForm.vue?vue&type=script&lang=js&"
export * from "./ApproveForm.vue?vue&type=script&lang=js&"
import style0 from "./ApproveForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports